import { LazyMotion, domAnimation, m, useReducedMotion } from 'motion/react';
import { Icon } from './Icon';
import './registrationExperience.css';

interface EventPosterProps {
  className?: string;
  eager?: boolean;
  compact?: boolean;
}

const POSTER_FULL = '/assets/12h-poster-2026.jpeg';
const POSTER_OPTIMIZED = '/assets/12h-poster-2026-720.jpeg';
const POSTER_OPTIMIZED_LARGE = '/assets/12h-poster-2026-1080.jpeg';
const POSTER_ALT = 'Pôster oficial do 12 HORAS COM FORTEENS, de 31 de julho às 20h até 1º de agosto às 8h';
export const EVENT_INSTAGRAM_POST = 'https://www.instagram.com/p/Da3uZH1gxcl/';

export function EventPoster({ className = '', eager = false, compact = false }: EventPosterProps): JSX.Element {
  const reduceMotion = useReducedMotion();

  return (
    <LazyMotion features={domAnimation} strict>
      <figure className={`fte-event-poster ${compact ? 'fte-event-poster--compact' : ''} ${className}`.trim()}>
        <m.a
          href={EVENT_INSTAGRAM_POST}
          target="_blank"
          rel="noopener noreferrer"
          className="fte-event-poster__trigger"
          aria-label="Abrir o pôster oficial no Instagram"
          whileHover={reduceMotion ? undefined : { y: -4, rotate: -0.35 }}
          whileTap={reduceMotion ? undefined : { scale: 0.985 }}
        >
          <span className="fte-event-poster__frame">
            <img
              src={POSTER_FULL}
              srcSet={`${POSTER_OPTIMIZED} 720w, ${POSTER_OPTIMIZED_LARGE} 1080w`}
              sizes={compact ? '(max-width: 640px) 88vw, 360px' : '(max-width: 640px) 92vw, 520px'}
              width="1080"
              height="1350"
              loading={eager ? 'eager' : 'lazy'}
              decoding="async"
              alt={POSTER_ALT}
            />
            <span className="fte-event-poster__shine" aria-hidden="true" />
            <span className="fte-event-poster__expand" aria-hidden="true"><Icon name="external" /></span>
          </span>
        </m.a>
        <figcaption>
          <span className="eyebrow">PÔSTER OFICIAL</span>
          <span>Abrir no Instagram</span>
        </figcaption>
      </figure>
    </LazyMotion>
  );
}
